<template>
  <div>
    <div class="tab">
      <ul>
        <li :class="{'is-active': isActiveTab(constantes.PRODUIT_FACES)}"
            @click="updateActiveTab(constantes.PRODUIT_FACES)" v-if="moduleFaceUnitaireIsActive">
          {{ $t('cartographie.tabs.selection.faces', { number: selection.produitFaces.length}) }}
        </li>
        <li :class="{'is-active': isActiveTab(constantes.PRODUIT_ECRANS)}"
            @click="updateActiveTab(constantes.PRODUIT_ECRANS)" v-if="moduleEcranNumIsActive">
          {{ $t('cartographie.tabs.selection.ecrans', { number: selection.produitEcrans.length}) }}
        </li>
        <li :class="{'is-active': isActiveTab(constantes.CLIENTS)}"
            @click="activeTab = 'clients'">
          {{ $t('cartographie.tabs.selection.clients', { number: selection.clients.length}) }}
        </li>
        <li :class="{'is-active': isActiveTab(constantes.RESEAUX)}"
            @click="updateActiveTab(constantes.RESEAUX)" v-if="moduleReseauTempoIsActive">
          {{ $t('cartographie.tabs.selection.reseaux', { number: selection.reseaux.length}) }}
        </li>
      </ul>
    </div>
    <face-selected
      v-if="activeTab === constantes.PRODUIT_FACES"
      :faces.sync="selection.produitFaces"
      @removeSelection="value => removeSelection('produitFaces', value)">
    </face-selected>
    <ecran-selected
      v-if="activeTab === constantes.PRODUIT_ECRANS"
      :ecrans.sync="selection.produitEcrans"
      @removeSelection="value => removeSelection('produitEcrans', value)">
    </ecran-selected>
    <client-selected
      v-if="activeTab === constantes.CLIENTS"
      :clients.sync="selection.clients"
      @removeSelection="value => removeSelection('clients', value)">
    </client-selected>
    <reseau-selected
      v-if="activeTab === constantes.RESEAUX"
      :reseaux.sync="selection.reseaux"
      @removeSelection="value => removeSelection('reseaux', value)">
    </reseau-selected>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import faceSelected from '@/components/outils/cartographie/l_faceInSelection';
import clientSelected from '@/components/outils/cartographie/l_clientInSelection';
import reseauSelected from '@/components/outils/cartographie/l_reseauInSelection';
import ecranSelected from '@/components/outils/cartographie/l_ecranInSelection';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'SelectionCartographie',
  props: {
    selection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: null,
      constantes: {
        PRODUIT_FACES: 'produitFaces',
        PRODUIT_ECRANS: 'produitEcrans',
        CLIENTS: 'clients',
        RESEAUX: 'reseaux',
      },
    };
  },
  components: {
    faceSelected,
    clientSelected,
    reseauSelected,
    ecranSelected,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleEcranNumIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEcranNumerique.key);
    },
    moduleFaceUnitaireIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key);
    },
    moduleReseauTempoIsActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    removeSelection(key, value) {
      this.selection[key] = this.selection[key].filter(s => !value.map(v => v.id).includes(s.id));
    },
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    updateActiveTab(activeTab) {
      this.activeTab = activeTab;
    },
  },
  async mounted() {
    await this.loadParametresInterne([
      PARAMETRES_INTERNE_KEYS.moduleEcranNumerique.key,
      PARAMETRES_INTERNE_KEYS.moduleProduitFaceUnitaire.key,
      PARAMETRES_INTERNE_KEYS.moduleProduitReseauTempo.key,
    ]);
    if (this.moduleFaceUnitaireIsActive) {
      this.updateActiveTab(this.constantes.PRODUIT_FACES);
    } else if (this.moduleEcranNumIsActive) {
      this.updateActiveTab(this.constantes.PRODUIT_ECRANS);
    } else {
      this.updateActiveTab(this.constantes.CLIENTS);
    }
  },
};
</script>

<style>

</style>
